"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeleniumBrowsers = exports.SupportedBrowsersList = exports.SupportedBrowsers = void 0;
var SupportedBrowsers;
(function (SupportedBrowsers) {
    SupportedBrowsers["Safari"] = "safari";
    SupportedBrowsers["MicrosoftEdge"] = "MicrosoftEdge";
    SupportedBrowsers["Firefox"] = "firefox";
    SupportedBrowsers["Opera"] = "opera";
    SupportedBrowsers["Chrome"] = "chrome";
    SupportedBrowsers["ChromeMobile"] = "chrome-mobile";
    SupportedBrowsers["Android"] = "android";
})(SupportedBrowsers = exports.SupportedBrowsers || (exports.SupportedBrowsers = {}));
exports.SupportedBrowsersList = [SupportedBrowsers.Android, SupportedBrowsers.Chrome, SupportedBrowsers.ChromeMobile, SupportedBrowsers.Firefox, SupportedBrowsers.MicrosoftEdge, SupportedBrowsers.Opera, SupportedBrowsers.Safari];
/**
 * This map should match as closely to the defaults given to us by Aerokube Moon, so when we add new versions we dont need to do much to add them.
 */
exports.SeleniumBrowsers = {
    safari: {
        default: '15.0',
        versions: ['15.0', '14.0', '13.0'],
    },
    MicrosoftEdge: {
        default: '98.0',
        versions: ['98.0', '97.0', '96.0', '95.0'],
    },
    firefox: {
        default: '98.0',
        versions: [
            '98.0',
            '97.0',
            '96.0',
            '95.0',
            '94.0',
            '93.0',
            '92.0',
            '91.0',
            '90.0',
            '89.0',
            '88.0',
            '87.0',
            '86.0',
            '85.0',
            '84.0',
            '83.0',
            '82.0',
            '81.0',
            '80.0',
            '79.0',
            '78.0',
            '77.0',
            '76.0',
            '75.0',
            '74.0',
            '73.0',
            '72.0',
            '71.0',
            '70.0',
            '69.0',
            '68.0',
            '67.0',
            '66.0',
            '65.0',
            '64.0',
            '63.0',
            '62.0',
            '61.0',
            '60.0',
            '59.0',
            '58.0',
            '57.0'
        ],
    },
    chrome: {
        default: '99.0',
        versions: [
            '99.0',
            '98.0',
            '97.0',
            '96.0',
            '95.0',
            '94.0',
            '93.0',
            '92.0',
            '91.0',
            '90.0',
            '89.0',
            '88.0',
            '87.0',
            '86.0',
            '85.0',
            '84.0',
            '83.0',
            '82.0',
            '81.0',
            '80.0',
            '79.0',
            '78.0',
            '77.0',
            '76.0',
            '75.0',
            '74.0',
            '73.0',
            '72.0',
            '71.0',
            '70.0'
        ],
    },
    'chrome-mobile': {
        default: '99.0',
        versions: [
            '99.0',
            '98.0',
            '97.0',
            '96.0',
            '95.0',
            '94.0',
            '93.0',
            '92.0',
            '91.0',
            '90.0',
            '89.0',
            '88.0',
            '87.0',
            '86.0',
            '85.0',
            '84.0',
            '83.0',
            '82.0',
            '81.0',
            '80.0',
            '79.0',
            '78.0',
            '77.0',
            '76.0',
            '75.0',
            '74.0',
            '73.0',
            '72.0',
            '71.0',
            '70.0'
        ]
    },
    opera: {
        default: '73.0',
        versions: [
            '73.0',
            '72.0',
            '71.0',
            '70.0',
            '69.0',
            '68.0',
            '67.0',
            '66.0',
            '65.0',
            '64.0',
            '63.0',
            '62.0',
            '60.0',
            '58.0',
            '57.0',
            '56.0',
            '55.0',
            '54.0',
            '53.0',
            '52.0',
            '51.0',
            '50.0',
            '49.0',
            '48.0',
            '47.0',
            '46.0',
            '45.0',
            '44.0',
            '43.0',
            '42.0',
            '41.0',
            '40.0',
            '39.0',
            '38.0',
            '37.0',
            '36.0',
            '35.0',
            '34.0',
            '33.0',
            '12.16',
        ],
    },
    android: {
        default: '10.0',
        versions: ['10.0', '9.0', '8.1', '8.0', '7.1', '7.0', '6.0', '5.1', '5.0', '4.4'],
    }
};
